// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function AttributeList(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : "md";
  return JsxRuntime.jsx("ul", {
    children: props.data.map((item, index) => {
      let value = item.value;
      return JsxRuntime.jsxs("li", {
        children: [
          value !== undefined ? JsxRuntime.jsx("span", {
              children: value,
              className: "mr-1 text-zinc-700 font-medium"
            }) : null,
          JsxRuntime.jsx("span", {
            children: item.title,
            className: "whitespace-nowrap"
          })
        ],
        className: "flex items-center mt-1 sm:mt-0 after:block after:content-[''] after:w-px after:h-3.5 after:bg-zinc-500 after:mx-2.5 last:after:content-none"
      }, index.toString());
    }),
    className: TailwindMerge.twMerge([
      "flex flex-wrap leading-6 text-zinc-500",
      size === "sm" ? "text-base" : "text-lg",
      Stdlib_Option.getOr(props.className, "")
    ])
  });
}

let make = AttributeList;

exports.make = make;
/* tailwind-merge Not a pure module */
